import { render, staticRenderFns } from "./UserReachedMaxBookingsModal.vue?vue&type=template&id=04514736&scoped=true"
import script from "./UserReachedMaxBookingsModal.vue?vue&type=script&lang=js"
export * from "./UserReachedMaxBookingsModal.vue?vue&type=script&lang=js"
import style0 from "./UserReachedMaxBookingsModal.vue?vue&type=style&index=0&id=04514736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04514736",
  null
  
)

export default component.exports